import staticStates from "./staticStates"

const mutations = staticStates.reduce(
  (obj, cur) => ({ ...obj, [cur]: (state, value) => (state[cur] = value) }),
  {}
)

const emptyStates = staticStates.filter(a => ['categorias','colecoes','tags'].indexOf(a) === -1).reduce(
  (obj, cur) => ({ ...obj, [cur]: null }),
  {}
)

Object.assign(mutations, {
  logout (state) {
    Object.assign(state, emptyStates)
  }
})

export default mutations
